// This is a wrapper directive for those components that are usually fullscreen
// and have a background image. In the component menu, that background remains
// fixed to the page body, but with this wrapper, the background moves with the
// component it belongs to.

// The "remove" portion of this is to allow individual components to be displayed
// in the component menu from a partial containing more than one component
// without having to copy/paste all over the place as was being done initially.

const amountComponentAttachBg = () => {
  return {
    restrict: 'EA',
    scope: {
      attachBgClass: "@",
      removeClass: "@",
    },
    link: (scope, element) => {
      if (!!scope.attachBgClass) {
        const bgElement = element.find(`.${scope.attachBgClass}`);
        bgElement.attr("style", "background-attachment: local");
      }

      if (scope.removeClass) {
        scope.removeClass.split(' ').forEach(cssClass => {
          const removeElement = element.find(`.${cssClass}`);
          removeElement.remove();
        });
      }
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountComponentAttachBg", amountComponentAttachBg);
